module.exports = __webpack_public_path__ + "img/eye-dropper-full.a24e6ec0.svg";